import React, { useEffect, useState } from 'react';
import '../solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionCentralOffice.mp4",
    poster: "/videos/solutionCentralOffice.jpg",
    heading: "Fiber Optic Basics in the Age of AI Data Centers",
    subheading: "Sep 12, 2024",
    buttonLink: "/support"
  }
];

function BlogFiberOpticBasics() {

const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [open, setOpen] = useState(new Set());

  const toggle = (key) => {
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };


const productFamilies = [
  'Fiber Cable Assemblies',
  'Fiber Panels',
  'Frames',
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products



useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="curved-header-sol2" style={{paddingBottom: 60}}>
        <div className="datacenter-left" style={{ paddingTop: 100}}>
            <h1>{slides[0].heading}</h1>
            <p style={{ marginBottom: 40, fontSize: 20}}>{slides[0].subheading}</p>
            </div>
            <div className="datacenter-right" style={{ paddingTop: 60}}>
              <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FEVA_16F-MMF_2x8_MPO-DXLCU_FA_with-cover.png?alt=media&token=1da6fccb-b00d-4ea1-a8c3-69984db328a3" className="datacenter-img" />
            </div>
            </div>



      <div className="blog-section-1" style={{ marginTop: 30}}>

          <p className="solution-section-1-description">As data centers evolve to support new AI companies and AI-based applications, fiber optic connectivity has become crucial. Fiber optic cables are preferred in data centers due to their high bandwidth, long-distance transmission, low latency, and resistance to electromagnetic interference (EMI). These fast, reliable connections between data centers and cloud providers enable quick data transfers and low latency, which is essential for cloud-based applications.<br/><br/>

<b>Key Facts About Fiber Optics</b><br/>

Fiber optic cables come in two main types: single-mode and multi-mode. Both types play vital roles in data centers.<br/><br/>

 <ul style={{margin: 0}}>
    <li>Single-Mode Fiber (SMF) has a smaller core diameter (about nine microns) and is ideal for long-distance transmission with higher bandwidth.</li>
    <li>Multi-Mode Fiber (MMF) has a larger core diameter (50 or 62.5 microns) and is used for shorter distances because it has higher attenuation (signal loss), and lower bandwidth compared to single-mode.</li>
  </ul>
<br/><br/>
The transmission distance of MMF depends on several factors, including the type of MMF, the data rate, and the transceivers used. SMF, due to its smaller core and the use of laser light, can carry data over much longer distances.<br/><br/>

While MMF is more affordable for short-distance applications, SMF, though costlier, is necessary for longer distances and higher speeds. SMF is often used in long-haul telecommunications, high-speed data centers, and campus-wide networks, whereas MMF is common in local area networks (LANs) and shorter, intra-building connections.<br/><br/>

<b>Fiber Types Comparison</b><br/>
<img src="images/blog/fiberTypesCompare.png" style={{height: 'auto', width: '80vw'}} />

<br/><br/>
<b>Fiber Optics: A Green, Powerful Solution</b><br/>
As data centers pack in more equipment and power, energy efficiency becomes a priority. Fiber optics are more energy-efficient than other cable types due to lower signal loss and reduced reliance on repeaters. They also support virtualization and cloud computing, reducing the need for physical hardware. Additionally, fiber enables better cable management, which is crucial for cooling, one of the most energy-intensive operations in data centers.<br/><br/>

Effective cable management improves airflow and reduces the need for excessive cooling, lowering power consumption. It also simplifies maintenance and troubleshooting, which cuts down on repair-related energy use and downtime.<br/><br/>

<b>Want to Learn More About Fiber Optics?</b><br/>
Check out the standards that govern fiber optic cabling in data centers. These standards ensure uniformity and compatibility in fiber optic infrastructure. Some key standards include:<br/><br/> 
 <ul style={{margin: 0}}>
    <li>TIA-942: Telecommunications Infrastructure Standard for Data Centers</li>
    <li>ISO/IEC 24764: International Standard for Data Center Cabling</li>
    <li>IEEE 802.3: Standards for Ethernet</li>

  </ul>

</p>
      </div>


        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions" style={{ backgroundColor: 'white'}}></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default BlogFiberOpticBasics;
